import {put, takeLatest} from 'redux-saga/effects';

//Actions
import * as actions from '../../actions';
import {AxiosResponse} from "axios";
import {AccountListResponse} from "../../types/Account";
import {fetchAccountList} from "../generic/saga";
import {ApiRingGroupListRequestPayload} from "../../actions/ringgroups/payloads";
import {ActionType} from "typesafe-actions";
import {AssignedExtension, RingGroupType} from "../../types/RingGroup";
import {pagedAsyncDataRequest, pagedDataRequest} from "../paged.data.saga";
import {Customer} from "../../../services/endpoints";

export const defaultAccountListFetchCount = 5000;

export function* getAgentsTabData(
    action: ActionType<typeof actions.getAgentsTabData.request>,
) {
    try {
        const accounts: AxiosResponse<AccountListResponse> = yield fetchAccountList(
            undefined,
            {
                has_extension: 1,
                get_only_real_accounts: 1,
                get_not_closed_accounts: 1,
                limit: defaultAccountListFetchCount,
            },
            true,
            true,
            true
        );

        const nameFilters: string[] = [];
        action.payload?.ringGroupFilter && nameFilters.push(action.payload?.ringGroupFilter.name)

        let hgPayload: ApiRingGroupListRequestPayload
        let huntGroupList: RingGroupType[] = []


        if (!nameFilters.length) {

            hgPayload = {
                limit: action.payload?.pageSize || 50,
                offset: action.payload?.page || 0,
                name: undefined
            }

            const res1:{response:{huntgroup_list:any[]} } =
                yield pagedAsyncDataRequest<RingGroupType>(Customer.GetHuntGroupList, hgPayload);

            huntGroupList = res1.response.huntgroup_list
            huntGroupList = huntGroupList.map(item => ({...item, cache_assigned_extensions: item.assigned_extensions}))

            const filteredTemp: RingGroupType[] = []

            if (action.payload.agentsFilter?.length) {

                huntGroupList.forEach(tempGroup => {

                    const newExtensions: AssignedExtension[] = []

                    action.payload.agentsFilter?.forEach(agent => {
                        tempGroup.assigned_extensions?.forEach(ext => {
                            if (ext.id == agent.id) {
                                newExtensions.push(ext)
                            }
                        })
                    })

                    filteredTemp.push({...tempGroup, assigned_extensions: newExtensions})

                });

                huntGroupList = [...filteredTemp]

            }


        } else {
            for (let i = 0; i < nameFilters.length; i++) {

                hgPayload = {
                    limit: action.payload?.pageSize || 50,
                    offset: action.payload?.page || 0,
                    name: nameFilters[i]
                }

                let temp: RingGroupType[] =
                    yield pagedDataRequest<RingGroupType>(Customer.GetHuntGroupList, hgPayload, (data) => data.huntgroup_list);

                temp = temp.map(item => ({...item, cache_assigned_extensions: item.assigned_extensions}))

                const filteredTemp: RingGroupType[] = []

                if (action.payload.agentsFilter?.length) {

                    temp.forEach(tempGroup => {

                        const newExtensions: AssignedExtension[] = []

                        action.payload.agentsFilter?.forEach(agent => {
                            tempGroup.assigned_extensions?.forEach(ext => {
                                if (ext.id == agent.id) {
                                    newExtensions.push(ext)
                                }
                            })
                        })

                        filteredTemp.push({...tempGroup, assigned_extensions: newExtensions})

                    });

                    huntGroupList = [...huntGroupList, ...filteredTemp]

                } else {
                    huntGroupList = [...huntGroupList, ...temp]
                }

            }
        }

        const tempAgents: AssignedExtension[] = [];
        huntGroupList.forEach(group => {

            if (group.assigned_extensions?.length) {
                group.assigned_extensions.forEach(item => !tempAgents.find(tempItem => tempItem.id == item.id && item.type == 'Account') && tempAgents.push(item));
            }
        })

        if (action.payload.isInit) {
            yield put(actions.cacheAgents({agents: tempAgents}));
        }

        yield put(actions.getAgentsTabData.success({
            accounts: {...accounts.data},
            huntGroupList: {huntgroup_list: [...huntGroupList], total: huntGroupList.length},
            agents: tempAgents
        }));

    } catch (err) {
        yield put(actions.getAgentsTabData.failure());
    }
}

export function* fetchRestOfAccountsForAgentTab() {
    try {
        const accounts: AxiosResponse<AccountListResponse> = yield fetchAccountList(
            undefined,
            {
                has_extension: 1,
                get_only_real_accounts: 1,
                get_not_closed_accounts: 1,
                limit: defaultAccountListFetchCount,
                offset: defaultAccountListFetchCount,
            },
            true,
            true,
            true,
            true
        );

        yield put(actions.fetchRestOfAccountsForAgentTab.success({
            accounts: {...accounts.data},
        }));

    } catch (err) {
        yield put(actions.fetchRestOfAccountsForAgentTab.failure());
    }
}

export const agentsSaga = [
    takeLatest(actions.getAgentsTabData.request, getAgentsTabData),
    takeLatest(actions.fetchRestOfAccountsForAgentTab.request, fetchRestOfAccountsForAgentTab),
];